namespace Gamification.Gamification {
    export namespace UtentiProdottiEsperienzeDashboardService {
        export const baseUrl = 'Gamification/UtentiProdottiEsperienzeDashboard';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiEsperienzeDashboardRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiEsperienzeDashboardRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiEsperienzeDashboardRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiEsperienzeDashboardRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiEsperienzeDashboard/Create",
            Update = "Gamification/UtentiProdottiEsperienzeDashboard/Update",
            Delete = "Gamification/UtentiProdottiEsperienzeDashboard/Delete",
            Retrieve = "Gamification/UtentiProdottiEsperienzeDashboard/Retrieve",
            List = "Gamification/UtentiProdottiEsperienzeDashboard/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiEsperienzeDashboardService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
